import React from 'react';
import { Callout, List, P, Path, Steps, Sub, Table, UI } from '../ui';

export const Rooms: React.FC = () => (
  <>
    <P>
      왼쪽 탭 바의 <UI>대화방</UI> 탭을 누르면 내가 참여 중인 모든 대화방이 하나의 목록으로 표시됩니다.
      나와의 채팅과 고정한 방이 위쪽에, 나머지는 최근 대화 순으로 정렬됩니다.
    </P>

    <Table
      head={['구분', '설명']}
      rows={[
        ['나와의 채팅', '나 혼자만 쓰는 메모장 같은 공간. 항상 목록 맨 위에 표시됩니다'],
        ['채널', '부서나 전사 단위의 공개 대화방. 관리자가 만들며 공지 전용으로 운영되기도 합니다'],
        ['그룹 채팅', '여러 명을 초대해서 만드는 대화방. 누구나 만들 수 있습니다'],
        ['개인 메시지', '1:1 대화. 하나도 없으면 목록에 아예 표시되지 않습니다'],
      ]}
    />

    <Sub>1:1 대화 시작하기</Sub>
    <P>
      대화 상대를 찾는 방법은 세 가지입니다. 어느 쪽이든 이름이나 사진을 누르면 그 사람의 <b>프로필</b>이 열리고,
      프로필 아래의 <UI>1:1 대화</UI> 버튼을 누르면 1:1 대화방이 열립니다.
    </P>
    <List>
      <>
        <b>온라인</b> — 왼쪽 탭 바의 <UI>온라인</UI> 탭(모바일은 화면 아래 <UI>온라인</UI> 탭)을
        눌러 회사 → 부서 순으로 펼쳐 이름을 클릭합니다.
      </>
      <>
        <b>멤버 목록</b> — 그룹 대화방의 <UI>멤버</UI> 버튼을 눌러 목록에서 이름을 클릭합니다.
      </>
      <>
        <b>대화 속 프로필 사진</b> — 그룹 대화방에서 다른 사람 메시지 옆의 프로필 사진을 누릅니다.
      </>
    </List>

    <Callout tone="info">
      <p>
        이미 대화한 적이 있으면 기존 대화방이 열리고, 처음이라면 새로 만들어집니다. 내 이름은 <UI>(나)</UI>로
        표시되며 클릭할 수 없습니다.
      </p>
      <p>
        이름이나 부서로 찾으려면 <UI>대화방 개설</UI> 창의 검색 칸을 쓰세요. 한 명만 고르면 1:1 대화방이 열립니다.
        계열사가 여러 개인 환경에서는 검색 칸 위의 드롭다운으로 다른 계열사 직원도 찾을 수 있습니다.
      </p>
    </Callout>

    <Sub>프로필 보기</Sub>
    <P>
      프로필에는 <b>프로필 사진, 접속 상태, 이름, 소속(회사·부서), 메일 주소</b>가 나옵니다. 1:1 대화방에서는 위쪽
      제목(상대방 사진과 이름)이나 상대방 메시지 옆의 사진을 누르면 프로필이 열리며, 이미 그 사람과 대화 중이므로{' '}
      <UI>1:1 대화</UI> 버튼은 나오지 않습니다.
    </P>
    <List>
      <>
        메일 주소 옆의 <b>복사</b> 버튼을 누르면 주소가 복사됩니다. <b>메일 쓰기</b> 버튼을 누르면 PC에 설정된 기본
        메일 프로그램(휴대폰은 메일 앱)에서 받는 사람이 채워진 새 메일 창이 열립니다.
      </>
      <>인트라넷에 메일 주소를 등록하지 않은 사람은 <UI>등록된 메일 주소가 없습니다</UI>로 표시됩니다.</>
    </List>

    <Sub>그룹 대화방 만들기</Sub>
    <Steps>
      <>
        <UI>대화방</UI> 목록 오른쪽 위의 <UI>+</UI> 버튼을 누릅니다.
      </>
      <>
        검색 칸에서 초대할 사람을 찾습니다. 검색 결과는 <b>부서별로 묶여</b> 표시되고, 부서 이름 오른쪽의{' '}
        <UI>전체 선택</UI>을 누르면 그 부서 전원을 한 번에 넣을 수 있습니다.
      </>
      <>
        선택한 사람은 위쪽에 이름표로 모입니다. 잘못 넣었다면 이름표의 <UI>×</UI>로 뺍니다.
      </>
      <>
        <UI>다음</UI>을 누릅니다. 한 명만 골랐다면 그 사람과의 1:1 대화가 바로 열립니다.
      </>
      <>
        <b>채팅방 이름</b>과 설명을 입력합니다. 둘 다 선택 사항이며 이름은 최대 50자, 설명은 최대 100자입니다.
      </>
      <>
        <UI>개설</UI>을 누르면 대화방이 만들어지고 바로 그 방으로 이동합니다. 초대한 사람들의 대화방에는
        &ldquo;○○님이 …님을 초대했습니다&rdquo; 안내가 함께 남습니다.
      </>
    </Steps>
    <P>아무도 선택하지 않으면 다음 버튼이 눌리지 않습니다. 본인은 자동으로 포함됩니다.</P>
    <Callout tone="info" title="이름을 비워 두면 참여자 이름으로 보입니다">
      <p>
        이름을 정하지 않은 방은 사람마다 <b>자기를 뺀 참여자 이름</b>으로 보입니다. 예를 들어 세 사람이 있는 방은
        각자에게 나머지 두 사람의 이름으로 보이고, 누가 들어오거나 나가면 이름도 바로 바뀝니다. 혼자 남으면
        &ldquo;대화 상대 없음&rdquo;으로 보입니다.
      </p>
    </Callout>

    <Sub>멤버 초대와 확인</Sub>
    <List>
      <>
        <b>초대</b> — 그룹 대화방 위쪽의 <UI>초대</UI> 버튼. 이미 들어와 있는 사람은 목록에 나오지 않습니다.
      </>
      <>
        <b>멤버 목록</b> — <UI>멤버</UI> 버튼을 누르면 인원수와 함께 명단이 열립니다. 방장은 왕관, 관리자는
        방패 아이콘이 붙고 참여한 날짜와 현재 접속 상태가 표시됩니다. 목록을 열어둔 채로 누가 들어오거나 나가면
        자동으로 갱신됩니다.
      </>
    </List>

    <Sub>대화방 고정하기, 알림 끄기</Sub>
    <P>
      대화방 목록에서 방을 <b>마우스 오른쪽 버튼으로 클릭</b>하면 관리 메뉴가 나옵니다. 모바일에서는
      대화방을 <b>0.5초 이상 길게 누르면</b> 같은 메뉴가 열립니다.
    </P>
    <Table
      head={['메뉴', '효과', '표시']}
      rows={[
        [
          '채팅방 고정',
          '그 대화방이 목록 맨 위로 올라갑니다. 자주 쓰는 방을 찾기 쉬워집니다',
          '이름 옆에 압정 아이콘',
        ],
        [
          '알림 끄기',
          '팝업 알림과 화면 깜빡임이 멈춥니다',
          '이름 옆에 종에 빗금 친 아이콘',
        ],
      ]}
    />
    <P>
      고정한 대화방은 홈의 <b>즐겨찾기</b>에도 나타납니다. 홈 즐겨찾기의 <UI>추가</UI>를 누르면 대화방 목록으로
      가지 않고 그 자리에서 방을 골라 올리거나 내릴 수 있습니다. 검색창에 동료 이름을 넣으면 그 사람과의 1:1
      대화방과 그 사람이 있는 대화방이 함께 나옵니다.
    </P>
    <Callout tone="warn" title="알림을 꺼도 안 읽은 개수는 계속 올라갑니다">
      <p>
        알림 끄기는 &ldquo;방해하지 않기&rdquo;에 가깝습니다. 팝업만 뜨지 않을 뿐 메시지는 정상적으로 도착하고
        빨간 숫자 배지도 계속 증가합니다. 나중에 몰아서 확인하고 싶은 방에 쓰면 좋습니다.
      </p>
    </Callout>
    <P>고정과 알림 설정은 계정에 저장되므로 PC에서 바꾸면 노트북·웹에서도 똑같이 적용됩니다.</P>

    <Sub>목록 걸러 보기</Sub>
    <P>
      대화방 목록 위쪽의 <UI>전체 / 안읽음 / 그룹</UI> 버튼으로 목록을 좁힐 수 있습니다. <UI>그룹</UI>을 누르면{' '}
      <b>여러 명이 함께 쓰는 그룹 대화방만</b> 남습니다 — 1:1 대화와 공지 채널, 나와의 채팅은 보이지 않습니다.
      돋보기 검색과 함께 쓰면 두 조건이 모두 적용됩니다. <UI>전체</UI>를 누르면 원래 목록으로 돌아옵니다.
    </P>

    <Sub>대화방 검색</Sub>
    <P>
      대화방 목록 위쪽의 <UI>돋보기</UI> 버튼을 누르면 검색 칸이 열립니다. <b>대화방 이름</b>,{' '}
      <b>참여자 이름</b>, <b>대화방 설명</b> 세 가지 중 하나만 맞아도 목록에 남습니다. 사람 이름을 입력하면
      그 사람과의 1:1 대화뿐 아니라 <b>그 사람이 참여한 그룹 대화방도 함께</b> 나옵니다. 대화 내용을 찾는
      검색이 아니라 <b>방을 찾는</b> 검색입니다 (대화 내용 검색은 대화창 안의 돋보기 버튼을 이용하세요).
    </P>
    <P>
      공지 채널은 계열사 전원이 참여자라서 사람 이름으로는 걸리지 않습니다 — 이름이나 설명으로 찾으세요.
    </P>

    <Sub>안 읽은 메시지 표시</Sub>
    <List>
      <>대화방 오른쪽의 빨간 동그라미 숫자가 안 읽은 메시지 개수입니다. 100개가 넘으면 99+로 표시됩니다.</>
      <>목록을 접어두었더라도 제목 줄에 그 그룹 전체의 합계가 표시되므로 놓치지 않습니다.</>
      <>대화방을 클릭해 들어가면 숫자가 사라집니다.</>
      <>
        대화방 목록 위쪽의 <UI>전체 / 안읽음 / 그룹</UI> 버튼에서 <UI>안읽음</UI>을 누르면{' '}
        <b>안 읽은 메시지가 있는 방만</b> 모아 볼 수 있습니다. <UI>전체</UI>를 누르면 원래 목록으로 돌아옵니다.
      </>
    </List>

    <Sub>대화방 이름 바꾸기</Sub>
    <P>
      그룹 대화방을 <b>마우스 오른쪽 클릭</b>(모바일은 <b>길게 누르기</b>)하면 뜨는 메뉴의{' '}
      <UI>대화방 이름 변경</UI>으로 방 이름을 바꿀 수 있습니다. 대화방 안에서는 상단 메뉴(⋮)에도 같은 항목이
      있습니다. 이름은 50자까지이며, 그룹의 참여자라면 누구나 바꿀 수 있습니다.
    </P>
    <Callout tone="info" title="이름은 참여자 모두에게 똑같이 바뀝니다">
      <p>
        나에게만 보이는 별칭이 아니라 방 자체의 이름이 바뀝니다. 바꾸면 대화방 안에 &ldquo;○○님이 대화방 이름을
        &hellip;(으)로 변경했습니다&rdquo; 안내 메시지가 남아 누가 언제 바꿨는지 모두가 알 수 있습니다.
        참여자 이름으로 보이던 방도 한 번 이름을 정하면 그 뒤로는 누가 들어오거나 나가도 이름이 바뀌지 않습니다.
        1:1 대화와 공지 채널, 나와의 채팅은 이름을 바꿀 수 없습니다.
      </p>
    </Callout>

    <Sub>대화방 나가기</Sub>
    <P>
      대화방 목록에서 방을 <b>마우스 오른쪽 클릭</b>(모바일은 <b>길게 누르기</b>)하면 뜨는 메뉴의{' '}
      <UI>채팅방 나가기</UI>로 그룹 대화방이나 1:1 대화에서 나갈 수 있습니다. 공개 채널은 나갈 수 없습니다.
    </P>
    <Callout tone="danger" title="1:1 대화를 나가면 이전 내용은 다시 볼 수 없습니다">
      <p>
        1:1 대화에서 나가면 목록에서 사라지고 <b>그동안 주고받은 대화 내용도 다시 보이지 않습니다.</b> 상대가
        새 메시지를 보내면 새 대화방으로 다시 시작됩니다. 나가기 전에 확인 창이 한 번 더 뜹니다.
      </p>
    </Callout>

    <Sub>공지 전용 채널</Sub>
    <P>
      일부 공개 채널은 읽기 전용으로 운영됩니다. 이런 방에 들어가면 입력창 대신{' '}
      <UI>공지 전용 채널입니다.</UI> 라는 안내가 표시되며 메시지 작성과 파일 첨부가 모두 막힙니다. 공지 내용을
      확인하는 용도로만 사용하세요.
    </P>
    <P>
      또한 공개 채널은 소속 계열사에 맞는 것만 보입니다. 다른 계열사 전용 채널은 목록에 나타나지 않습니다.
    </P>
  </>
);
